/**
 * Paste / URL recipe import UI telemetry (ProductUiEvent via trackUiEvent).
 * Durable quality metrics live in recipe_paste_import_logs (server-side).
 */

import { trackUiEvent } from './uiAnalytics.js'

export const RECIPE_IMPORT_SURFACES = {
  COOK_ADD: 'cook_add',
}

/**
 * @param {string} event
 * @param {Record<string, string|number|boolean|null|undefined>} [properties]
 */
export function trackRecipeImportEvent(event, properties = {}) {
  trackUiEvent(event, {
    feature_area: 'recipe_import',
    ...properties,
  })
}

/**
 * Flatten missing_fields into scalar flags for ProductUiEvent property sanitizer.
 * @param {string[]|undefined|null} missingFields
 */
export function missingFieldsAsProps(missingFields) {
  const list = Array.isArray(missingFields) ? missingFields : []
  const props = {
    missing_field_count: list.length,
    missing_fields_csv: list.slice(0, 12).join(',').slice(0, 500) || null,
  }
  for (const key of list.slice(0, 12)) {
    const safe = String(key).replace(/[^a-z0-9_]/gi, '_').slice(0, 40)
    if (safe) props[`missing_${safe}`] = true
  }
  return props
}
